/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Înapoi',
      changePassword: 'Modificare',
      copiedVaultId: 'Copiat!',
      copyVaultID: 'Copiați ID-ul Vault',
      create: 'Creați',
      next: 'Următor',
      notSure: 'Nu știu sigur',
      signUp: 'Înscrie-te',
      submit: 'Trimitere',
      updatePassword: 'Actualizează parola',
    },
    Errors: {
      createReportFailed: 'Crearea raportului a eșuat.',
    },
    ReportStatus: {
      CLOSED: 'Închis',
      INVESTIGATING: 'În curs de investigare',
      NEW: 'Trimis',
      READ: 'Citire',
    },
    general: {
      navbar: {
        caseSettings: 'Setări de caz',
        changePassword: 'Schimbă parola',
        logOut: 'Deconectare',
        notifications: 'Notificări',
        notificationsDrawer: {
          appFileScanFailed: 'Un fișier a eșuat verificarea de securitate',
          appReportMatch: 'Înregistrarea dvs. GoTogether a fost potrivită',
          appReportReassigned: 'Un nou manager de caz a fost atribuit',
          case: 'Caz',
          caseAssigned: 'Caz atribuit vouă',
          caseImporterJobCompleted: {
            PartialSuccess: 'Importul cazului tău s-a finalizat cu erori',
            failure: 'Importul cazului tău a eșuat',
            success: 'Importul cazului tău a fost finalizat cu succes',
          },
          caseLinked: 'Caz asociat',
          caseTeamInvite: 'Adăugat la caz',
          caseUnlinked: 'Cazul este delinkat',
          dataSanitisation: 'Detaliile raportului au fost actualizate',
          emptyDescription: 'Verifică mai târziu pentru notificări noi',
          emptyTitle: 'Ești la curent cu tot',
          importId: 'ID import:',
          learnMore: 'Aflați mai mult',
          markAllAsRead: 'Marchează toate ca citite',
          newMessage: 'Mesaj nou',
          newReport: 'Raport nou primit',
          permissionRemoved: 'Eliminat din caz',
          postSSubmissionFile: 'Fișier(e) de dovezi adăugat(e)',
          report: 'Raport',
          reportAssigned: 'Raportul îți este atribuit',
          reportStatusChange: 'Starea raportului a fost modificată',
          reporterAnonymised: 'Detaliile dvs. au fost anonimizate',
          reporterReportSubmitted: {
            subtitle: 'Vă recomandăm să păstrați o copie a raportului dvs.',
            title: 'Raport depus',
          },
          mitigationPlanReminder:
            'Este necesară aprobarea planului de atenuare',
          staleCase: 'Caz neacționat',
        },
        privacyStatement: 'Declarație de confidențialitate',
        reporter: {
          myReports: 'Rapoartele mele',
        },
        settings: 'Setări',
        technicalSupport: 'Asistență tehnică',
        title: 'Cont',
      },
      time: {
        day: 'Ziua',
        days: 'Zile',
        hour: 'Ora',
        hours: 'Ore',
        minute: 'Minut',
        minutes: 'Minute',
        second: 'Secundă',
        seconds: 'Secunde',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonim',
        autoTranslate: 'Traducerea automată este dezactivată în mod implicit.',
        backToMessages: 'Înapoi la mesaje',
        caseSettings: 'Setări de caz.',
        changeInProfile:
          'Dacă dorești să modifici această setare, o poți face în profilul tău',
        deletedByMessage: 'Șters de {{author}}',
        deletedMessageLabel: 'Acest mesaj a fost șters',
        description:
          'Când traducerea automată este activată, toate mesajele raportului vor fi\n          traduse automat folosind AI bazat pe limba implicită\n          selectată pe browserul dvs.',
        descriptionSecondHalf:
          'Versiunea originală a tuturor mesajelor este întotdeauna păstrată și poate fi găsită în chat.',
        messagePlaceholder: 'Începeți să tastați...',
        messageSettings: 'Setări mesaj.',
        originalMessages: 'Original',
        showMoreBanner: 'Aflați mai multe despre traducerile automate',
        titlev2: 'Citește toate mesajele în limba ta preferată.',
        translatedMessageLabel: 'Mesaj tradus',
        translatedMessages: 'Tradus',
        understood: 'Înțeles',
      },
      Country: {
        description: 'În ce țară vă aflați?',
        header: 'În ce țară vă aflați?',
        noOptions: 'Nu s-au găsit țări',
        other: 'Altul',
        placeholder: 'Căutați o țară...',
      },
      CreatePublicReport: {
        createReport: 'Creați un raport',
        helpPage: 'Mergeți la pagina noastră de ajutor',
        loginToOpr: 'Conectați-vă pentru a urmări rapoartele',
        or: 'sau',
        passwordPlaceholder: 'Introduceți parola',
        phoneNumberLoginFailed:
          'Conectare eșuată, numărul de telefon/PIN incorect',
        phoneNumberPlaceholder: 'Introduceți numărul dvs. de telefon',
        phoneNumberTooltip:
          'Introduceți numărul de telefon folosit pentru a contacta VaultTalk',
        pinPlaceholder: 'Introduceți codul PIN',
        reportIntroductionParagraph1:
          'Atunci când raportați un incident, vi se vor pune câteva întrebări pentru a vă sprijini în documentarea experienței dumneavoastră.',
        reportIntroductionParagraph2:
          'Înainte de trimitere, aveți opțiunea de a rămâne anonim pentru a vă proteja confidențialitatea.',
        reportIntroductionParagraph3:
          'După depunere, vă puteți conecta în orice moment pentru a vedea evoluția raportului dvs. și pentru a discuta cu un manager de caz.',
        reportIssue: 'Raportați o problemă',
        usernameLoginFailed:
          'Conectare eșuată, numărul de telefon/PIN incorect',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Relația cu compania este necesară.',
            reportedCategoryRequired: 'Categoria raportată este necesară',
          },
        },
        vaultId: 'ID-ul Vault',
        vaultIdPlaceholder:
          'Introduceți adresa dvs. de e-mail sau ID-ul VaultD-ul Vault',
        vaultIdTooltip:
          'Pentru rapoartele anonime, ID-ul Vault este alfanumeric. Dacă raportul nu a fost anonim, ID-ul Vault este adresa dvs. de e-mail',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Parola dvs.',
        yourPhoneNumber: 'Numărul dvs. de telefon',
        yourPin: 'PIN-ul dvs. cu 6 cifre',
        yourVaultId: 'ID-ul dvs. Vault',
      },
      CustomHeader: {
        companyLogo: 'Logo {{company}}',
        openReporting: 'Raportare deschisă',
        userSettings: 'Setări utilizator',
      },
      Date: {
        approximateDescription:
          'Vă amintiți data aproximativă la care a avut loc evenimentul?',
        approximatePlaceholder:
          'Exemplu: acum 6 luni / anul trecut / noiembrie anul trecut',
        cancel: 'anulare',
        clear: 'ștergere',
        description: 'Vă amintiți data la care a avut loc evenimentul?',
        header: 'În ce zi a avut loc?',
        ok: 'ok',
        placeholder: 'Exemplu: 21 iunie 2020',
      },
      Description: {
        whatHappened: 'Ce s-a întâmplat?',
        whatHappenedPlaceholder: 'Folosiți propriile cuvinte...',
        whatHappenedText: 'Descrieți în propriile cuvinte ce s-a întâmplat',
      },
      Details: {
        disclaimer:
          'Aceste detalii vor fi divulgate împreună cu raportul dumneavoastră. Dacă doriți să vă păstrați anonimitatea, asigurați-vă că acestea nu conțin informații de identificare.',
        emailPlaceholder: 'E-mail (opțional)',
        fullNamePlaceholder: 'Nume complet (opțional)',
        header: 'Datele dumneavoastră',
        nonAnonSubtitle:
          'Vă rugăm să furnizați fie numele dvs., fie o adresă de e-mail. Dacă doriți să primiți notificări despre acest raport, adăugați o adresă de e-mail corespunzătoare mai jos.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Nume complet',
        subtitle:
          'Dacă doriți să primiți notificări cu privire la acest raport, adăugați mai jos o adresă de e-mail corespunzătoare.',
      },
      Emotion: {
        description: 'Cum v-a făcut să vă simțiți? Care a fost impactul?',
        header: 'Care a fost impactul?',
        placeholder: 'Începeți să tastați...',
      },
      Evidence: {
        addedHeading: 'Adăugat',
        deletedMessage: 'a fost șters',
        deletedStatus: 'Șters',
        failedToOpenFileMessage:
          'Fișierul nu s-a deschis. Vă rugăm să încercați din nou',
        fileStatuses: {
          infectedUpload: 'Semnalat prin verificare de securitate',
          passedUpload: 'A trecut controlul de securitate',
          pendingUpload: 'Verificare de securitate în curs',
          readyForDownload: 'Gata pentru descărcare',
        },
        mobileErrorMessage:
          'Fișiere marcate: trimiteți un mesaj managerului de caz',
        nameHeading: 'Nume și prenume',
        statusHeading: 'Stare',
        tableTitle: 'Dovezi',
        webErrorMessage:
          'Fișiere marcate: dacă fișierele dvs. au fost marcate, vă rugăm să trimiteți un mesaj managerului de caz',
      },
      FileUpload: {
        addFiles: 'Adăugați fișiere',
        addMoreFiles: 'Adăugați mai multe fișiere',
        confirm: 'Confirmați',
        description:
          'Adăugarea de fișiere ca dovezi poate contribui la eficientizarea soluționării de către managerul de caz. Vă rugăm să țineți cont de conținutul fișierului (inclusiv metadatele fișierului) dacă doriți să vă păstrați anonimitatea și să respectați drepturile altor persoane și legile aplicabile.',
        dragDrop: 'Plasați fișierele aici sau',
        errorMessage:
          'Fișierele au eșuat din cauza unei erori de rețea. Faceți clic mai jos pentru a trimite un mesaj managerului dvs. de caz pentru asistență',
        fileLimit: 'Limita dimensiunii fiecărui fișier: 100MB',
        fileUploadLimitText: 'Puteți încărca doar 10 fișiere',
        header: 'Adăugați dovezi',
        helpArticle: 'articolul de ajutor',
        highlighted: 'răsfoiți fișierele',
        information: 'Tipuri de fișiere acceptate',
        moreInformation:
          'Pentru mai multe informații, vă rugăm să consultați <a>articolul de ajutor</a>',
        postSubmissionErrorMessage:
          'Nu am putut încărca fișierele dvs. din cauza unei erori de sistem. Vă rugăm să selectați din nou „Confirmare”.',
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documente:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Imagini:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Fișierul este prea mare',
          invalidFileType: 'Tip de fișier neacceptat: {{extension}}',
          systemError: 'Eroare de sistem',
          tooManyFiles: 'Numărul maxim de fișiere este {{maxFiles}}',
        },
        uploadFiles: 'Încărcați fișiere',
      },
      Loading: {
        loading:
          'Vă rugăm să așteptați în timp ce trimitem raportul dvs. unui manager de caz...',
        postSubmissionLoading:
          'Vă rugăm să așteptați în timp ce trimitem fișierele dvs...',
      },
      Location: {
        description: 'Unde s-a întâmplat?',
        header: 'Unde s-a întâmplat?',
        placeholder: 'Exemplu: la birou',
      },
      MessageListBox: {
        messageCaseManager: 'Manager de caz pentru mesaje',
        report: 'Raport {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Traducerea dezactivată',
        enableTranslationLabelEnabled: 'Traducere activată',
        enableTranslationsDescription:
          'Activați traducerile automate și citiți toate mesajele de raport în limba preferată. Limba tradusă se bazează pe limba selectată pe dispozitivul dvs.',
        enableTranslationsHeader:
          'Activează traducerea automată pentru mesajele de raport',
        enableTranslationsSubDescriptionv2:
          'Puteți comuta între limba tradusă și limba originală în fiecare chat.',
        updateTranslationFailed: 'Actualizarea traducerii a eșuat',
        updateTranslationSuccess:
          'Setarea de traducere a fost actualizată cu succes',
      },
      Password: {
        changePasswordHeader: 'Modificare',
        createNewPassword: 'Vă rugăm să creați o parolă nouă',
        createPasswordHeader: 'Parola dvs.',
        currentPasswordPlaceholder: 'Introduceți parola curentă',
        description:
          'O parolă validă trebuie să aibă cel puțin 9 caractere și să includă o majusculă și un număr',
        enterCurrentPassword: 'Vă rugăm să introduceți parola curentă',
        forgottenPasswordInstructions:
          'Introduceți ID-ul alfanumeric Vault (nu adresa dvs. de e-mail) și adresa de e-mail pentru a vă reseta parola.',
        newDescription:
          'Creează o parolă puternică pentru a-ți menține contul în siguranță. Începe să tastezi pentru a vedea instrucțiunile de mai jos.',
        passwordPlaceholder: 'Creați o parolă',
        passwordResetRequestedDescription:
          'Dacă ID-ul tău Vault există în sistemul nostru, vei primi un email cu instrucțiuni pentru resetarea parolei tale.',
        passwordResetRequestedHeader: 'Link pentru resetarea parolei solicitat',
        reenterPlaceholder: 'Introduceți din nou parola',
        subtitle:
          'Creați o parolă pentru a trimite acest raport și pentru a-l accesa în viitor',
        yourVaultId: 'ID-ul tău Vault',
        yourVaultIdPlaceholder:
          'Introduceți ID-ul dvs. Vault (de ex. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Raportați o anumită persoană sau mai multe persoane? Puteți să le numiți sau să le descrieți?',
        header: 'Persoane implicate',
        placeholder:
          'Începeți să tastați și folosiți virgulă pentru a adăuga mai multe nume sau descrieri',
      },
      PoweredByVault: 'Susținut de {{company}}',
      PrivacyStatement: 'Declarația de confidențialitate a produsului',
      PublicMessageList: {
        myMessages: 'Mesajele mele',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Dovezi adăugate la raportul existent',
        backToReportId: 'Înapoi la raportul ID: {{reportId}}',
        description:
          'Adăugarea de fișiere ca dovezi poate contribui la eficientizarea soluționării de către managerul de caz. Vă rugăm să țineți cont de conținutul fișierului (inclusiv metadatele fișierului) dacă doriți să vă păstrați anonimitatea să respectați drepturile altor persoane și legile aplicabile. Pentru mai multe informații, vă rugăm să consultați <a>articolul de ajutor</a>',
        header: 'Adăugați dovezi suplimentare la raport',
        vaultTalkOpenCaseHeader: 'Adăugați dovezi la raportul dvs.',
      },
      PublicReport: {
        anonymous: 'Anonim',
        backToReports: 'Înapoi la rapoarte',
        skipped: 'Sărit',
      },
      PublicReportCard: {
        addEvidence: 'Adăugați dovezi suplimentare',
        messageCaseManager: 'Manager de caz pentru mesaje',
        reportId: 'ID raport:',
        submitted: 'Trimis',
        vaultTalkClosedCaseCTA: 'Vedeți dovezi',
        vaultTalkOpenCaseCTA: 'Adăugați dovezi',
        viewAdditionalEvidence: 'Vedeți dovezi suplimentare',
        viewReport: 'Vedeți raportul',
      },
      PublicReportsList: {
        reportingSystem: 'Sistemul de raportare',
      },
      Question: {
        placeholder: 'Începeți să tastați...',
        question: 'Furnizați detalii',
        questionText:
          'Vă rugăm să ne împărtășiți îngrijorarea, noutățile sau solicitarea dvs.',
      },
      Relationship: {
        header: 'Relația dumneavoastră cu organizația',
        tellUsAbout:
          'Vă rugăm să ne spuneți despre relația dumneavoastră cu organizația.',
      },
      ResponsiveNavMenu: {
        messages: 'Mesajele mele',
        reports: 'Rapoartele mele',
      },
      Site: {
        description: 'La ce sediu sunteți?',
        header: 'La ce sediu sunteți?',
        noOptions: 'Niciun sediu găsit',
        other: 'Altul',
        placeholder: 'Căutați un sediu...',
      },
      SpamPuzzle: {
        dialog: 'Pentru a continua, vă rugăm să rezolvați acest puzzle',
      },
      SubmissionTypes: {
        reportIssue: 'Selectați o categorie',
        whatType: 'Selectați categoria care descrie cel mai bine raportul dvs.',
      },
      SubmitSuccess: {
        category: '<bold>Categorie:</bold> {{category}}',
        country: '<bold>Țară:</bold> {{country}}',
        dateSubmitted: '<bold>Data trimisă:</bold> {{date}}',
        recordYourVaultID: 'Rețineți aceste informații pentru autentificare',
        successInformation: 'Mai multe informații',
        successMessage:
          'Raportul dvs. a fost trimis și este gata pentru examinare. Orice fișier atașat care necesită atenție va fi marcat la conectare. Conectați-vă mai jos pentru a vizualiza actualizările raportului și pentru a trimite mesaje managerului dvs. de caz.',
        successSanitationMessage:
          'Salvați o copie pentru înregistrările dumneavoastră și păstrați-vă Vault-ID în siguranță - veți avea nevoie de el pentru a accesa actualizări și pentru a îi trimite mesaje managerului dumneavoastră de caz.',
        successSanitationTagline:
          'Raportul dvs. a fost trimis și stocat în siguranță.',
        successThankYou: 'Vă mulțumim pentru raportul dumneavoastră!',
        viewReport: 'Vedeți raportul',
      },
      Time: {
        approximateDescription:
          'Vă amintiți ora aproximativă la care a avut loc evenimentul?',
        approximatePlaceholder: 'Exemplu: dimineața, după-amiaza',
        description: 'Vă amintiți ora la care a avut loc evenimentul?',
        header: 'La ce oră s-a întâmplat?',
        invalidTime: 'Formatul orei trebuie să fie HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Modificarea parolă',
        closeDialog: 'Închideți dialogul',
        logout: 'Deconectare',
        messageSettings: 'Setări mesaje',
        userSettings: 'Setări utilizator',
      },
      Witnesses: {
        description: 'Ați mai spus cuiva sau a văzut cineva ce s-a întâmplat?',
        header: 'Vreun martor?',
        placeholder: 'Începeți să tastați...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Trimite mesaj',
        title: 'Mesaj Manager de Caz',
        translationHeader: 'Aflați mai multe despre traducerile automate',
      },
      ReportCard: {
        addEvidence: 'Adaugă dovadă',
        submissionModeVia: 'prin {{submissionMode}}',
        viewEvidence: 'Vizualizați dovezi',
      },
      ReportList: {
        yourReports: 'Rapoartele tale',
      },
      ReportingActivate: {
        buttonText: 'Continuați',
        description:
          'Dacă organizația dumneavoastră v-a înregistrat pentru un cont, vă vom trimite un email cu instrucțiuni pentru a finaliza configurarea.',
        emailInput: 'E-mail',
        header: 'Introduceți adresa de email de serviciu',
        successAccount:
          'Dacă organizația ta te-a înregistrat pentru un cont, îți vom trimite un e-mail cu instrucțiuni pentru a finaliza configurarea.',
        successEmail:
          'Dacă nu îl vedeți imediat, vă rugăm să așteptați câteva minute și să actualizați casuța de e-mail.',
        successHeading: 'Mulțumesc',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Adaugă dovezi la raportul tău',
        descriptionText:
          'Adăugarea de fișiere ca dovadă poate ajuta la îmbunătățirea eficienței rezolvării de către managerul de caz. Luați în considerare conținutul fișierului (inclusiv metadatele fișierului) dacă doriți să rămâneți anonim și respectați drepturile altor persoane și legile aplicabile. Pentru mai multe informații, vă rugăm să consultați acest <a>articol de ajutor</a>',
        emptyMessage: 'Niciun dovezi suplimentare încărcate',
      },
      ReportingChangePassword: {
        back: 'Înapoi',
        description:
          'Creează o parolă puternică pentru a-ți menține contul în siguranță. Începe să tastezi pentru a vedea îndrumări mai jos.',
        errorToast: 'Nu se poate crea parola, token invalid.',
        header: 'Schimbare Parolă',
        incorrectCurrentPassword:
          'Parola curentă este greșită. Te rog verific-o și încearcă din nou.',
        invalidToken: 'Token invalid',
        passwordUpdated: 'Parola actualizată',
        passwordUpdatedDescription:
          'Parola dumneavoastră a fost actualizată cu succes. Mulțumim pentru că ați făcut acest pas pentru a vă păstra datele în siguranță!',
        passwordUsedBefore: 'Reutilizarea parolei nu este permisă',
        passwordUsedBeforeDescription:
          'Pentru siguranța dumneavoastră, nu puteți reutiliza niciuna dintre ultimele șase parole. Vă rugăm să alegeți o parolă nouă și unică pentru a vă menține contul în siguranță și încercați din nou.',
        toastDescription:
          'Parola dumneavoastră a fost actualizată cu succes. Mulțumim că ați luat acest pas pentru a vă păstra datele în siguranță!',
        toastMessage: 'Parola actualizată',
        updatePasswordCTA: 'Actualizează parola',
      },
      ReportingConnect: {
        cancelButton: 'Anuleaza',
        connectButton: 'Conectează-te',
        disclaimer:
          'Conectarea contului tău Slack cu contul tău Vault asigură o conexiune sigură și privată.<br /><br />Prin conectare, poți raporta un comportament neregulamentar sau poți adresa o întrebare direct în Slack. Vei avea întotdeauna opțiunea de a raporta în mod anonim după conectare. Confidențialitatea și securitatea ta sunt prioritățile noastre de top.',
        heading:
          'Vault Platform solicită permisiunea de a accesa contul tău Slack {{organisationName}}',
        listHeading: 'Ce va putea să facă Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault va avea capacitatea de a vedea identitatea utilizatorului tău de pe Slack.',
          heading:
            'Vizualizează informațiile despre identitatea unui utilizator',
        },
        permissionNotifications: {
          extraInfo:
            'Vault va putea să vă trimită notificări pe contul dvs. Slack, referitoare la orice actualizări ale unui raport sau întrebare trimise.',
          heading: 'Vă trimite notificări',
        },
        permissionOverview: {
          extraInfo:
            'Vault va afișa o prezentare generală a tuturor înregistrărilor pe pagina de acasă.',
          heading: 'Prezentare generală a submisilorilor',
        },
        permissionSubmitReport: {
          extraInfo:
            'Acest lucru îi va acorda lui Vault permisiunea de a trimite un raport sau de a pune o întrebare, direct către organizația dvs., din Slack.',
          heading: 'Trimite un raport sau o întrebare în numele tău',
        },
        successfulConnectionDescription:
          'Contul dvs. Vault și contul Slack sunt acum conectate. Acum puteți închide această filă și puteți reveni la Slack.',
        successfulConnectionHeading: 'Conectare cu succes',
        unsuccessfulConnectionDescription:
          'Ceva nu a mers bine. Vă rugăm să închideți această filă și să reveniți la Slack pentru a încerca din nou.',
        unsuccessfulConnectionHeading: 'Conexiune eșuată',
      },
      ReportingForgotPassword: {
        description:
          'Introduceți adresa de e-mail asociată cu contul dvs. și vă vom trimite un link pentru a vă reseta parola.',
        heading: 'Parolă uitată',
        invalidTokenError: 'Nu se poate crea parola, token invalid.',
        passwordReuseError: 'Reutilizarea parolei nu este permisă',
        passwordReuseErrorDescription:
          'Pentru siguranța dvs., nu puteți reutiliza niciuna dintre ultimele șase parole. Vă rugăm să alegeți o parolă nouă și unică pentru a vă menține contul sigur și încercați din nou.',
        sendLink: 'Trimite link de resetare',
        sendLinkFailure: 'Ceva nu a mers bine',
        sendLinkFailureDescription:
          'Întoarce-te la <a>Hub-ul Reporter</a> și încearcă din nou. Dacă problema persistă, contactează-ne la <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link pentru resetarea parolei trimis',
        sendLinkSuccessDescription:
          'Am trimis un link de resetare a parolei la {{email}}',
        updatePasswordSuccess: 'Parola actualizată',
        updatePasswordSuccessDescription:
          'Parola dvs. a fost actualizată cu succes. Mulțumim că ați luat această măsură pentru a vă menține datele în siguranță!',
      },
      ReportingLogin: {
        accountFrozen: 'Contul este înghețat',
        accountLocked:
          'S-a încercat conectarea de prea multe ori în mod incorect. Contul este blocat pentru până la 1 oră. Resetarea parolei nu este posibilă în acest timp.',
        accountLockedPermanently:
          'Contul dumneavoastră a fost blocat. Utilizați resetarea parolei pentru a recăpăta accesul sau contactați administratorul sistemului pentru ajutor suplimentar.',
        createAccountCTA: 'Înregistrează-te pentru un cont',
        currentPassword: 'Parola curentă',
        emailLabel: 'Emailul tău',
        forgotPassword: 'Ți-ai uitat parola?',
        loginButton: 'Autentificare',
        newPasswordPlaceholder: 'Parolă nouă',
        passwordFailMessage:
          'Întoarce-te la aplicația Vault în Slack și încearcă din nou. Dacă problema persistă, contactează-ne la techsupport@vaultplatform.com',
        passwordFailTitle: 'Ceva nu a mers bine',
        passwordLabel: 'Parola dvs.',
        passwordPlaceholder: 'Introduceți parola dumneavoastră',
        passwordResetRequired: 'Resetare parolă necesară',
        passwordSuccessfullySetMessage:
          'Reveniți la aplicația Vault din Slack și autentificați-vă cu noua dumneavoastră parolă pentru a continua de unde ați rămas.',
        passwordSuccessfullySetTitle: 'Parola a fost setată cu succes',
        reenterPlaceholder: 'Reintroduceți parola',
        title: 'Centrul pentru Reporteri',
        tooltip:
          'Dacă nu ați setat încă o parolă pentru aplicația Vault, urmați aici pentru a începe. Dacă v-ați uitat parola, folosiți linkul "Ai uitat parola" de mai jos.',
        usernameLoginFailed:
          'Conectare eșuată, nume de utilizator sau parolă incorectă',
      },
      ReportingReset: {
        failureDescription:
          'Reveniți la aplicația Vault în Slack și încercați din nou. Dacă problema persistă, contactați-ne la <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Ceva nu a mers bine',
        successDescription:
          'Întoarce-te la aplicația Vault în Slack și autentifică-te cu noua ta parolă pentru a continua de unde ai rămas.',
        successHeading: 'Parola a fost setată cu succes',
      },
      noReports: {
        description:
          'Toate rapoartele trimise vor apărea aici. Aflați mai multe despre modurile în care puteți trimite un raport în',
        descriptionHelpArticle: 'acest articol de ajutor',
        errorDescription:
          'Ne străduim să încărcăm rapoartele dumneavoastră. Vă rugăm să încercați să reîmprospătați pagina.',
        errorDescriptionSecondary:
          'Dacă acest lucru nu funcționează, vă rugăm să ne contactați la',
        errorTitle: '⚠️ Hopa, ceva nu a mers bine',
        title: 'Nu ai încă niciun raport',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Activați traducerile automate și citiți toate mesajele de raport în limba preferată. Limba tradusă este bazată pe limba selectată pe dispozitivul dvs.',
          autoTranslationDescription2:
            'Puteți comuta între limba tradusă și limba originală în fiecare chat.',
          autoTranslationTitle:
            'Activează traducerile automate pentru mesajele de raportare',
          header: 'Setări Mesaj',
          subHeader: 'Configurați modul în care sunt afișate mesajele',
        },
        notificationSettings: {
          emailDescription:
            'Primiți notificări prin e-mail pentru actualizări importante ale rapoartelor dumneavoastră.',
          emailTitle: 'Notificări prin email',
          header: 'Setări notificări',
          subHeader: 'Configurați modul în care primiți notificări',
        },
        title: 'Setări',
        updatedSettingsFailure: 'Actualizarea setărilor dvs. a eșuat',
        updatedSettingsSuccess: 'Setările au fost actualizate cu succes',
      },
    },
    validators: {
      passwordLength: 'Parola trebuie să aibă cel puțin 9 caractere',
      passwordLowercase: 'Parola trebuie să conțină cel puțin o literă mică',
      passwordMissMatch:
        'Parola și câmpurile de confirmare trebuie să coincidă.',
      passwordNumeric: 'Parola trebuie să conțină cel puțin 1 număr',
      passwordUppercase: 'Parola trebuie să conțină cel puțin o literă mare',
    },
    validatorsNew: {
      passwordLength: 'Între 10 și 30 de caractere',
      passwordLowercase: 'Cel puțin o literă mică',
      passwordMissMatch: 'Parolele nu se potrivesc',
      passwordNumeric: 'Cel puțin un număr',
      passwordSpecialCharacter: 'Cel puțin un caracter special',
      passwordUppercase: 'Cel puțin o literă mare',
    },
  },
};

export default translations;
